export const isMobile = (window: Window, mobileMaxWidth: number) => {
  return window.innerWidth < mobileMaxWidth;
};
